import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppService } from 'src/app/core/services/app.service';
import { FocuslinkService } from 'src/app/core/services/focuslink.service';
import { OOVenueService } from 'src/app/core/services/venue-service';
import { OOCanvas } from 'src/app/shared/models/oo-canvas';
import { OOCanvasMenuItem } from 'src/app/shared/models/oo-canvas-menu-item.model';
import { OOMenuItem } from 'src/app/shared/models/oo-menu-item';
import { OOCanvasMenuItemTimeRange } from 'src/app/shared/models/OOCanvasMenuItemTimeRange.entity';
import { OOTimeRanges } from 'src/app/shared/models/OOTimeRanges.entity';

@Component({
	selector: 'app-canvas-menu-item-createEdit',
	templateUrl: './canvas-menu-item-create.component.html',
	styleUrls: ['../../../../commandcenter.scss'],
})
export class CanvasMenuItemCreateComponent implements OnInit {
	@Input() ooCanvasMenuItem: OOCanvasMenuItem; //REQUIRED

	@Input() ooMenuItem: OOMenuItem;

	@Input() ooCanvas: OOCanvas;

	@Input() newRecord: boolean;
	@Input() sourceComponent: string;
	@Input() venueKey: number; //REQUIRED

	@Output() ooCanvasMenuItemEmitter: EventEmitter<OOCanvasMenuItem> = new EventEmitter<OOCanvasMenuItem>();
	@Output() closeEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

	changesToSave: boolean = false;

	itemPriceOptions: {
		label: string;
		value: number;
	}[] = [];

	duplicateOoCanvasMenuItemDetected: boolean = false;

	timeRangeListLoadingPlaceholder: string = 'Loading...';

	constructor(public app: AppService, private focuslink: FocuslinkService, public venueSvc: OOVenueService) {}

	ngOnInit(): void {
		if (this.ooCanvasMenuItem.OOCanvasMenuItemTimeRange && this.ooCanvasMenuItem.OOCanvasMenuItemTimeRange.length > 0) {
			this.ooCanvasMenuItem.OOCanvasMenuItemTimeRange.forEach((cmitr) => {
				cmitr.name = this.venueSvc.timeRanges.find((tr) => tr.key === cmitr.timeRangeKey).name;
			});
		}
		if (this.ooCanvasMenuItem.menuItemKey) {
			this.itemPriceOptions = this.venueSvc.menuItemPriceOptions(this.ooCanvasMenuItem.ooMenuItem);
			if (this.ooCanvasMenuItem.ooMenuItem.priceLevel) {
				this.itemPriceOptions.push({
					label: 'Use Price Level',
					value: 0,
				});
			}
			this.itemPriceOptions.sort((a, b) => a.value - b.value);
		}
	}

	/**
	 * This function was original to be used with restricting a user from selecting more preselected items than the canvas allows.
	 * However in retrospect, the canvas does not have a max value so it cannot be done.
	 */

	// evaluateExistingPreselectedItemOnCanvas(state: boolean) {
	// 	if (state) {
	// 		console.log(`evaluateExistingPreselectedItemOnCanvas`);

	// 		if (
	// 			this.ooCanvas.max === 1 &&
	// 			this.ooCanvas.menuItems.some((canItem) => canItem.preselected && canItem.menuItemKey !== this.ooMenuItem?.menuItemKey)
	// 		) {
	// 			const existingPreselectedCanvasItem = this.ooCanvas.menuItems.find(
	// 				(canItem) => canItem.preselected && canItem.menuItemKey !== this.ooMenuItem?.menuItemKey
	// 			);
	// 			if (existingPreselectedCanvasItem) {
	// 				this.app.confirmation.confirm({
	// 					message: `${existingPreselectedCanvasItem.ooMenuItem?.name} is already set as preselected for this canvas. Replace it?`,
	// 					accept: async () => {
	// 						this.changePreselectedItem(existingPreselectedCanvasItem, this.ooCanvasMenuItem);
	// 					},
	// 					reject: async () => {
	// 						this.ooCanvasMenuItem.preselected = false;
	// 						this.app.confirmation.close();
	// 					},
	// 				});
	// 			}
	// 		}
	// 		if (this.ooCanvas.max > 1) {
	// 			const existingPreselectedItems = this.ooCanvas.menuItems.reduce((acc, curr) => (curr.preselected ? (acc += 1) : acc), 0);
	// 			console.log(existingPreselectedItems);
	// 			if (existingPreselectedItems > this.ooCanvas.max) {
	// 				this.ooCanvasMenuItem.preselected = false;
	// 				this.app.confirmation.confirm({
	// 					message: `This canvas is set for a Max of ${this.ooCanvas.max}. You already have ${this.ooCanvas.max} items preselected. Please remove another preselected item if you want to make this item preselected`,
	// 					rejectVisible: false,
	// 					acceptLabel: 'OK',
	// 					accept: async () => {
	// 						this.app.confirmation.close();
	// 					},
	// 					reject: async () => {
	// 						this.app.confirmation.close();
	// 					},
	// 				});
	// 			}
	// 		}
	// 	}
	// }

	// async changePreselectedItem(oldItem: OOCanvasMenuItem, newItem: OOCanvasMenuItem) {
	// 	oldItem.preselected = false;
	// 	this.venueSvc.canvasMenuItemSave(oldItem);
	// }

	async ooCanvasGet(venueKey: number) {
		const resp = await this.focuslink.getOOCanvases(this.venueKey);
		this.venueSvc.ooCanvases = resp.map((i) => new OOCanvas(i));
		if (this.ooCanvasMenuItem.canvasKey) {
			this.ooCanvasMenuItem.ooCanvas = this.venueSvc.ooCanvases.find((i) => i.canvasKey === this.ooCanvasMenuItem.canvasKey);
		}
		const tempCanvasList = [...this.venueSvc.ooCanvases];
		tempCanvasList.forEach((canvas) => {
			canvas.menuItems.forEach((canMenuItem) => {
				if (canMenuItem.menuItemKey === this.ooCanvasMenuItem.menuItemKey) {
					this.venueSvc.ooCanvases.splice(
						this.venueSvc.ooCanvases.findIndex((i) => i.canvasKey === canvas.canvasKey),
						1
					);
				}
			});
		});
	}

	async onSave(rec: OOCanvasMenuItem) {
		if (rec.priceNumber === 0) {
			rec.priceLevelEnforced = true;
		} else {
			rec.priceLevelEnforced = false;
		}
		this.venueSvc.canvasMenuItemSave(rec);

		this.ooCanvasMenuItemEmitter.emit(rec);
	}

	async setOOMenuItem(menuItemKey) {
		const targetCanvas = this.venueSvc.ooCanvases.find((i) => i.canvasKey === this.ooCanvasMenuItem.canvasKey);
		this.duplicateOoCanvasMenuItemDetected = targetCanvas.menuItems?.some((i) => i.menuItemKey === this.ooCanvasMenuItem.menuItemKey) ? true : false;
		if (!this.duplicateOoCanvasMenuItemDetected) {
			this.ooCanvasMenuItem.ooMenuItem = this.venueSvc.ooMenuItems.find((i) => i.menuItemKey === menuItemKey);
			this.ooCanvasMenuItem.displayName = this.ooCanvasMenuItem.ooMenuItem.name;
		}
		this.itemPriceOptions = this.venueSvc.menuItemPriceOptions(this.ooCanvasMenuItem.ooMenuItem);
	}

	async setOOCanvasKey(canvasKey) {
		const targetCanvas = this.venueSvc.ooCanvases.find((i) => i.canvasKey === canvasKey);
		this.duplicateOoCanvasMenuItemDetected = targetCanvas.menuItems.some((i) => i.menuItemKey === this.ooCanvasMenuItem.menuItemKey) ? true : false;
		if (!this.duplicateOoCanvasMenuItemDetected) {
			this.ooCanvasMenuItem.ooCanvas = this.venueSvc.ooCanvases.find((i) => i.canvasKey === canvasKey);
		}
	}

	async timeRangeGet(venueKey) {
		const resp = await this.focuslink.timeRangeGetAll(venueKey);
		this.venueSvc.timeRanges = resp.map((i) => new OOTimeRanges(i));
		this.timeRangeListLoadingPlaceholder = 'Select Available Times (if applicable)';
		for (let timeRange of this.ooCanvasMenuItem.OOCanvasMenuItemTimeRange) {
			timeRange.name = this.venueSvc.timeRanges.find((i) => i.key === timeRange.timeRangeKey).name;
		}
	}

	timeRangeSelect(event) {
		if (!this.ooCanvasMenuItem.OOCanvasMenuItemTimeRange) {
			this.ooCanvasMenuItem.OOCanvasMenuItemTimeRange = [];
		}
		this.ooCanvasMenuItem.OOCanvasMenuItemTimeRange.push(
			new OOCanvasMenuItemTimeRange({
				venueKey: this.ooCanvasMenuItem.venueKey,
				canvasKey: this.ooCanvasMenuItem.canvasKey,
				menuItemKey: this.ooCanvasMenuItem.menuItemKey,
				timeRangeKey: event.value,
				name: this.venueSvc.timeRanges.find((i) => i.key === event.value).name,
			})
		);
	}

	timeRangeRemove(key) {
		this.ooCanvasMenuItem.OOCanvasMenuItemTimeRange.splice(
			this.ooCanvasMenuItem.OOCanvasMenuItemTimeRange.findIndex((i) => i.timeRangeKey === key),
			1
		);
	}
}
